import { formatDDMMYY, isSameUKDay, startOfUKDay, subDays } from './dateUtils';

/**
 * Returns a short label for the selected date for use in chart titles
 *
 * @param selectedDate - The currently selected date
 * @returns "(Today)", "(Yesterday)", or "(DD/MM/YY)"
 *
 * @example
 * getDateLabel(new Date()) // returns "(Today)"
 * getDateLabel(subDays(new Date(), 1)) // returns "(Yesterday)"
 * getDateLabel(new Date('2026-01-15')) // returns "(15/01/26)"
 */
export const getDateLabel = (selectedDate: Date | null | undefined): string => {
  if (!selectedDate) return '';

  const selected = startOfUKDay(selectedDate);
  const today = startOfUKDay();
  const yesterday = startOfUKDay(subDays(new Date(), 1));

  if (isSameUKDay(selected, today)) {
    return '(Today)';
  }

  if (isSameUKDay(selected, yesterday)) {
    return '(Yesterday)';
  }

  return `(${formatDDMMYY(selected)})`;
};

export default getDateLabel;
